<!-- 新建/编辑学校管理 -->
<template>
  <el-main>
    <div class="tableList">
      <div class="tableContent" :style="{padding:'10px 15px'}">
        <div class="cropper-app">
          <el-form :model="formValidate" :rules="ruleValidate" ref="formValidate" class="demo-ruleForm">
            <el-form-item label="学校名称" prop="name">
              <div class="list-img-box">
                <el-input placeholder="请输入学校名称" v-model="formValidate.name"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="城市" prop="cityId">
              <div class="list-img-box">
                <el-select v-model="formValidate.cityId" placeholder="请选择城市" :style="{width:'100%'}">
                   <el-option v-for="item in this.$route.query.cityList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="学校地址" prop="address">
              <div class="list-img-box">
                <el-input placeholder="请输入学校地址" v-model="formValidate.address"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="学校英文名" prop="ename">
              <div class="list-img-box">
                <el-input placeholder="请输入学校英文名" v-model="formValidate.ename"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="学校简称" prop="introduction">
              <div class="list-img-box">
                <el-input placeholder="请输入学校简称" v-model="formValidate.introduction"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="学校别名" prop="alias">
              <div class="list-img-box">
                <el-input placeholder="请输入学校别名" v-model="formValidate.alias"></el-input>
              </div>
            </el-form-item>
          </el-form>
          <!-- 保存 -->
          <div :style="{textAlign:'center'}">
            <el-button  size="medium" type="primary" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor, width:'150px'}" @click="onConfirm">保存</el-button>
            <el-button  size="medium" :style="{width:'150px'}" @click="onCancel">取消</el-button>
          </div>
        </div>
      </div>
    </div>
  </el-main>
</template>

<script>
  export default {
    name: 'SchoolManagementOperation',
    data () {
      return {
        formValidate: {
          name: '',//添加学校名称
          cityId: '',//添加城市名称
          address: '',//添加学校地址
          ename: '',//添加学校英文名
          introduction: '',//添加学校简称
          alias: '',//添加学校别名
        },
        ruleValidate: { //学校非空验证
          name: [
            { required: true, message: '请输入学校名称', trigger: 'blur'}
          ],
          cityId: [
            { required: true, message: '请选择城市名称', trigger: 'change'}
          ],
        },
      }
    },
    methods: {
      // 提交上传
      onConfirm() {
        this.$refs['formValidate'].validate( (valid) => {
            if (valid) {
              let params = {},title="新增";
              if (this.$route.query.data == undefined){
                params = {
                  name:this.formValidate.name,
                  cityId:this.formValidate.cityId,
                  address:this.formValidate.address,
                  ename:this.formValidate.ename,
                  introduction:this.formValidate.introduction,
                  alias:this.formValidate.alias,
                  status:1
                }
                this.$route.query.tableData.push(params);
              } else {
                params = {
                  id:this.$route.query.data.id,
                  cityId:this.formValidate.cityId,
                  name:this.formValidate.name,
                  address:this.formValidate.address,
                  ename:this.formValidate.ename,
                  introduction:this.formValidate.introduction,
                  alias:this.formValidate.alias,
                  status:1
                }
                for (let i = 0; i < this.$route.query.tableData.length; i++){
                  if(this.$route.query.tableData[i].id == this.$route.query.data.id){
                    this.$route.query.tableData[i] = params;
                  }
                }
                title = "编辑";
              }
              this.$api.saveOrUpdateSchoolAssistantBatch({parameter: JSON.stringify(this.$route.query.tableData)}).then(res => {
                if (res.data.status == 200) {
                  this.$message({
                    type: 'success',
                    message: title+'成功！'
                  });
                  this.$router.push('/SchoolManagement');
                } else {
                  this.$message({
                    type: 'error',
                    message: res.data.message
                  });
                }
              });
            }
        })
      },
      //返回上一页
      onCancel(){
        this.$router.push('/SchoolManagement');
      }
    },
    mounted(){
      if (this.$route.query.data != undefined){
        this.formValidate.name = this.$route.query.data.name;
        this.formValidate.cityId = this.$route.query.data.cityId;
        this.formValidate.address = this.$route.query.data.address;
        this.formValidate.ename = this.$route.query.data.ename;
        this.formValidate.introduction = this.$route.query.data.introduction;
        this.formValidate.alias = this.$route.query.data.alias;
      }
    }
  }
</script>

<style scoped>
  @import "../../assets/css/detaileds.css";/* 列表样式 */
</style>





// WEBPACK FOOTER //
// src/components/Menu/SchoolManagementOperation.vue